import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import ProductsCreateEditForm from './Components/ProductsCreateEditForm';
import ProductsApi from './ProductsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: ProductsCreateEditForm,
                getCreate: ProductsApi.create,
                defaults: { sizing: [] },
                successMessage: "Products Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}